const map = {
	"./img_Bus/TrendAnalysis/arrowremovebgpreview.png": "./src/componets/assets/img_Bus/TrendAnalysis/arrowremovebgpreview.png",
	"./img_Bus/tml-logo.png": "./src/componets/assets/img_Bus/tml-logo.png",
	"./img_kratos/home_kratos_background.jpg": "./src/componets/assets/img_kratos/home_kratos_background.jpg",
	"./work_in_progress_blue_final.png": "./src/componets/assets/work_in_progress_blue_final.png"
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/componets/assets sync recursive \\.(png%7Cjpe%3Fg%7Csvg%7Cwebp)$";